import type { TextualEntry } from "@ebay/experience-types-ebay";

export interface Input {
  entries?: TextualEntry[];
  minValue?: string;
  maxValue?: string;
  showMinError?: boolean;
  showMaxError?: boolean;
  "on-min-price-change": (min: string) => void;
  "on-max-price-change": (max: string) => void;
}

export default class extends Marko.Component<Input> {
  handleMinPriceChange(event: { value: string }) {
    const value = event?.value ?? "";
    this.emit("min-price-change", value);
  }

  handleMaxPriceChange(event: { value: string }) {
    const value = event?.value ?? "";
    this.emit("max-price-change", value);
  }
}
